import React, { useEffect, useRef, useState } from 'react';
import './application.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import * as ReactDOM from 'react-dom';
import { useSearchParams } from 'react-router';
import moment from 'moment/moment';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import {
  calculatedViewMode,
  getFilterData, getInputPropsWithSearch, getJSONFromString,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  acceptApplication, applicationBatchCommand,
  applicationFieldsValidation, applicationFieldsValidationClear,
  archiveApplication,
  assignApplicationById,
  deleteApplication, deniedApplication, loadApplicationById, loadApplicationByIdClear, loadApplicationIdList,
  loadApplicationList, loadApplicationStatus, loadSmevCheckList, restoreApplication,
  returnApplication, reviewApplication, suspendedApplication,
  unarchiveApplication, unAssignApplicationById,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import { getApplicationData } from '../reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import ApplicationForm from './ApplicationForm';
import ApplicationView from './ApplicationView';
import {
  APPLICATION_STATUS,
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES,
  PROCEDURE_VEHICLE_TYPES,
  TYPE_ROLLBACK_ENUM,
  USER_COMMAND_NAMES,
} from '../../../configs';
import ApplicationSelectProcedure from './ApplicationSelectProcedure';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { showGlobalConfirm } from '../../System/actions';
import { getUsersData } from '../../User/reducer';
import { FORBIDDEN } from '../../../configs/serverStatusCodes';
import {
  applicationAdditionalColumns,
  applicationColumns,
  carrierColumns, szltColumns, vehicleColumns,
} from './applicationColumns';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import { rowFilterSettings } from '../../FilterTemplate/components/filter-settings';
import { VersionListDialog } from '../../RollbackVersion/components/VersionListDialog';
import { RollbackPlanDialog } from '../../RollbackVersion/components/RollbackPlanDialog';
import { createRollbackPlans } from '../../RollbackVersion/actions';
import { getRollbackVersionData } from '../../RollbackVersion/reducer';
import CheckBoxInput from '../../../components/fields/CheckBoxInput/CheckBoxInput';
import DropdownList from '../../../components/base/Dropdown/DropdownList';
import ApplicationReturn from './ApplicationReturn';
import ApplicationDenied from './ApplicationDenied';
import ApplicationSuspended from './ApplicationSuspended';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import ApplicationFilter from './ApplicationFilter';
import MobileApplicationFooter from './MobileApplicationFooter';
import MobileApplicationView from './MobileApplicationView';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';

export default function ApplicationPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const [showSelectProcedure, setShowSelectProcedure] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isBatchCommand, setIsBatchCommand] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isAssign, setIsAssign] = useState(false);
  const [showHistoryVersion, setShowHistoryVersion] = useState(false);
  const [showRollbackPlan, setShowRollbackPlan] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showReturnDialog, setShowReturnDialog] = useState(false);
  const [showDeniedDialog, setShowDeniedDialog] = useState(false);
  const [showSuspendedDialog, setShowSuspendedDialog] = useState(false);
  const [isAllPageRowsSelected, setIsAllPageRowsSelected] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const procedureText = searchParams.get('procedure');
  const [prevProcedures, sePrevProcedures] = useState(procedureText);
  const search = searchParams.get('search');
  const number = searchParams.get('number');
  const isDraft = searchParams.get('draft');
  const statusText = String(searchParams.get('status') || '');
  let status = [];
  if (statusText?.length) {
    status = statusText.split(',').map(Number);
  }
  const externalFilterName = searchParams.get('filter');
  const created_at = searchParams.get('created_at');
  const application_id = searchParams.get('application_id');
  const isNew = searchParams.get('new');
  let pageName = 'application';
  const procedure = getJSONFromString(procedureText) || [];
  if (procedure && procedure.length) { pageName = `application-${procedure.join(',')}`; }
  const filterName = `${pageName}-filter${externalFilterName}`;
  const inVehicle = procedure.some(i => PROCEDURE_VEHICLE_TYPES.includes(i));
  const inSzlt = procedure.some(i => PROCEDURE_SZLT_TYPES.includes(i));
  const inCarrier = procedure.some(i => PROCEDURE_CARRIER_TYPES.includes(i));

  const store = useStore();
  const {
    loadingList,
    list = [],
    listMeta = {},
    loadingApplicationStatus,
    currentApplication,
    applicationStatus,
    loadingFieldsValidation,
    loadingExportApplication,
    fieldsValidation,
  } = useSelector(getApplicationData);
  const { loadingUserList } = useSelector(getUsersData);
  const { formatMessage } = useIntl();

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    status: [
      APPLICATION_STATUS.NEW,
      APPLICATION_STATUS.CHECKING,
      APPLICATION_STATUS.SUSPENDED,
      APPLICATION_STATUS.UPDATED,
      APPLICATION_STATUS.REVIEW,
    ],
    created_at: defaultDate,
    procedure,
    view_mode: 2,
  };

  const {
    rollbackPlan,
  } = useSelector(getRollbackVersionData);

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  const [sort, setSort] = useState(getDefaultSort(applicationColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  useEffect(() => {
    if (!application_id) {
      setShowView(false);
      setIsEdit(false);
      loadData();
    }
  }, [application_id]);

  useEffect(() => {
    if (isDraft) {
      setValue('status', [APPLICATION_STATUS.DRAFT]);
    }
  }, [isDraft]);

  let title = '';
  let titleFull = '';
  if (inVehicle && !inSzlt && !inCarrier) { title = 'Журнал ЛТ'; }
  if (!inVehicle && inSzlt && !inCarrier) { title = 'Журнал СЗЛТ'; }
  if (isDraft) { title = 'Журнал Черновиков'; }
  if (!inVehicle && !inSzlt && inCarrier) { title = 'Журнал перевозчиков'; }
  if (procedure.length === 1) {
    // title = formatMessage({ id: `menu.application.${procedure[0]}` });
    titleFull = formatMessage({ id: `menu.application.${procedure[0]}` });
  }

  const handleSetUrlParams = params => {
    const result = Object.keys(params).reduce((acc, c) => {
      if (params[c]) {
        acc[c] = params[c];
      }
      return acc;
    }, {});
    setSearchParams(result);
  };

  const handleAddUrlParams = params => {
    const res = {};
    for (const entry of searchParams.entries()) {
      const [key, value] = entry;
      res[key] = value;
    }
    const keys = Object.keys(params);
    for (const key of keys) {
      res[key] = params[key];
    }
    setSearchParams(res);
  };
  const handleRemoveUrlParams = (names = []) => {
    const res = {};
    for (const entry of searchParams.entries()) {
      const [key, value] = entry;
      if (!names.includes(key)) {
        res[key] = value;
      }
    }
    setSearchParams(res);
  };

  const loadApplication = (id, assign) => {
    if (application_id || id) {
      const action = assign ? assignApplicationById : loadApplicationById;
      dispatch(action(application_id || id))
        .then(() => {
          dispatch(applicationFieldsValidation({ id: application_id || id })).catch(responseLogWithNotification);
          setShowView(true);
          if (assign) {
            setIsAssign(true);
          }
        })
        .catch(response => {
          handleSetUrlParams({ procedure: procedureText });
          if (response && response.status === FORBIDDEN) {
            return errorNotification('Загрузка обращения', 'Обращение обрабатывается другим пользователем');
          }
          errorNotification('Загрузка обращения', getResponseError(response));
        });
    }
  };

  const unAssign = id => {
    setIsAssign(false);
    return dispatch(unAssignApplicationById(id))
      .catch(response => {
        errorNotification('Загрузка обращения', getResponseError(response));
      });
  };

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].listMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData },
      sort,
    };
    const p1 = dispatch(loadApplicationList(requestData)).catch(responseLogWithNotification);
    const p2 = dispatch(loadApplicationStatus(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1, p2]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(loadApplication, [application_id]);
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  useEffect(() => setShowSelectProcedure(!!isNew), [isNew]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      if (!externalFilterName) {
        localStorage.setItem(filterName, JSON.stringify(values));
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, filterName, externalFilterName]);
  useEffect(() => {
    const d = getFilterData(filterName, defaultFilterValues);
    if (d.search && d.search !== search) {
      handleAddUrlParams({ search: d.search });
    }
    reset(d);
  }, [filterName]);
  useEffect(() => setValue('search', search), [search]);
  useEffect(() => setValue('number', number), [number]);
  useEffect(() => {
    if (status?.length) {
      setValue('status', status);
    }
  }, [JSON.stringify(status)]);
  useEffect(() => {
    if (created_at && String(created_at).length) {
      setValue('created_at', String(created_at).split(','));
    }
  }, [created_at]);
  useEffect(() => {
    setValue('procedure', getJSONFromString(procedureText) || []);
    if (prevProcedures !== procedureText) {
      handleClose();
      sePrevProcedures(procedureText);
    }
  }, [procedureText]);

  useEffect(() => {
    if (isAllPageRowsSelected && isBatchCommand) {
      dispatch(loadApplicationIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
      }).catch(responseLogWithNotification);
    }
  }, [isAllPageRowsSelected, isBatchCommand]);

  const handleSelectRow = item => {
    let select = item;
    if (selectedRow && selectedRow.id === item.id) {
      select = null;
    }
    setSelectedRow(select);
  };

  const handleCreate = () => {
    setShowSelectProcedure(true);
    setIsEdit(false);
    setShowView(false);
    setIsAssign(false);
    clearCurrentState();
  };

  const handleEdit = item => () => {
    if (!item) {
      return;
    }
    dispatch(assignApplicationById(item.id))
      .then(() => {
        dispatch(loadSmevCheckList(item.id)).catch(responseLogWithNotification);
        dispatch(applicationFieldsValidation({ id: item.id })).catch(responseLogWithNotification);
        setShowForm(true);
        setIsEdit(true);
        setShowView(false);
        setIsAssign(false);
      })
      .catch(response => {
        handleSetUrlParams({ procedure: procedureText });
        if (response.status === FORBIDDEN) {
          return errorNotification('Загрузка обращения', 'Обращение обрабатывается другим пользователем');
        }
        errorNotification('Загрузка обращения', getResponseError(response));
      });
  };

  const batchCommand = (items, key = 'Не задан', withAssign) => values => {
    handleClose();
    dispatch(applicationBatchCommand({
      items, key, withAssign, values,
    })).then(() => loadData()).catch(responseLogWithNotification);
  };

  const handleArchive = (item, isBach = false, isUnarchive) => () => {
    if (!isBach && !item) {
      return;
    }
    const action = item?.archived_at || isUnarchive ? unarchiveApplication : archiveApplication;
    const key = isUnarchive ? USER_COMMAND_NAMES.IN_ARCHIVED : USER_COMMAND_NAMES.ARCHIVED;

    if (!isBach && item) {
      dispatch(action(item.id))
        .then(() => {
          loadData();
          successNotification('Архивация обращения', 'Архивация прошла успешно');
        })
        .catch(response => errorNotification('Архивация обращения', getResponseError(response)));
    } else {
      if (isAllPageRowsSelected) {
        dispatch(loadApplicationIdList({
          filter: getValues(),
        })).then(data => {
          setSelected(data?.data);
          batchCommand(data?.data, key, true)();
        }).catch(responseLogWithNotification);
        return;
      }
      batchCommand(selected, key, true)();
    }
  };

  const handleDeleteAndRestore = item => () => {
    if (!item) {
      return;
    }
    const action = !item.deleted_at ? deleteApplication : restoreApplication;
    const title = !item.deleted_at ? 'Удаление обращения' : 'Восстановление обращения';
    dispatch(action(item.id))
      .then(() => {
        loadData();
        successNotification(title, 'Процесс прошел успешно');
      })
      .catch(response => errorNotification(title, getResponseError(response)));
  };

  const handleGroupRestore = () => {
    if (isAllPageRowsSelected) {
      dispatch(loadApplicationIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
        batchCommand(data?.data, USER_COMMAND_NAMES.RESTORE, false)();
      }).catch(responseLogWithNotification);
      return;
    }
    batchCommand(selected, USER_COMMAND_NAMES.RESTORE, false)();
  };

  const handleDelete = (item, isBach = false) => () => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      dispatch(showGlobalConfirm({
        confirmMessage: `Удаление обращения № ${item.mais_egu_id || 'Без номера'}`,
        confirmButtonText: 'Удалить',
        confirmClassName: 'remove-preset',
      })).then(() => {
        dispatch(deleteApplication(item.id)).then(() => {
          if (selectedRow === item.id) {
            setSelectedRow(null);
          }
          loadData();
          successNotification('Удаление обращения', 'Удаление прошло успешно');
        }).catch(response => {
          errorNotification('Удаление обращения', getResponseError(response));
        });
      }).catch(() => {});
    } else {
      if (isAllPageRowsSelected) {
        dispatch(loadApplicationIdList({
          filter: getValues(),
        })).then(data => {
          setSelected(data?.data);
          batchCommand(data?.data, USER_COMMAND_NAMES.DELETED, true)();
        }).catch(responseLogWithNotification);
        return;
      }
      batchCommand(selected, USER_COMMAND_NAMES.DELETED, true)();
    }
  };

  const handleReturn = (item, isBach = false) => () => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      setSelectedRow(item);
    } else {
      setIsBatchCommand(isBach);
    }
    setShowReturnDialog(true);
  };

  const handleDenied = (item, isBach = false) => () => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      setSelectedRow(item);
    } else {
      setIsBatchCommand(isBach);
    }
    setShowDeniedDialog(true);
  };
  const handleSuspended = (item, isBach = false) => () => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      setSelectedRow(item);
    } else {
      setIsBatchCommand(isBach);
    }
    setShowSuspendedDialog(true);
  };

  const handleAccept = (item, isBach = false) => () => {
    if (!isBach && !item) {
      return;
    }
    if (!isBach && item) {
      dispatch(acceptApplication(selectedRow?.id)).then(() => {
        successNotification('Обработка обращения', 'Удовлетворено');
        loadApplication();
      }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
    } else {
      if (isAllPageRowsSelected) {
        dispatch(loadApplicationIdList({
          filter: getValues(),
        })).then(data => {
          setSelected(data?.data);
          batchCommand(data?.data, USER_COMMAND_NAMES.ACCEPTED, true)();
        }).catch(responseLogWithNotification);
        return;
      }
      batchCommand(selected, USER_COMMAND_NAMES.ACCEPTED, true)();
    }
  };

  const returned = values => () => {
    if (!selectedRow) {
      return;
    }
    dispatch(returnApplication({ id: selectedRow.id, values })).then(() => {
      setShowReturnDialog(false);
      loadApplication();
      successNotification('Обработка обращения', 'Уведомление о возврате сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const denied = values => () => {
    if (!selectedRow) {
      return;
    }
    dispatch(deniedApplication({ id: selectedRow?.id, values })).then(() => {
      setShowDeniedDialog(false);
      loadApplication();
      successNotification('Обработка обращения', 'Уведомление об отказе сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const suspended = values => () => {
    if (!selectedRow) {
      return;
    }
    dispatch(suspendedApplication({ id: selectedRow.id, values })).then(() => {
      setShowSuspendedDialog(false);
      loadApplication();
      successNotification('Обработка обращения', 'Уведомление о приостановке сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const copyLink = item => () => {
    navigator.clipboard.writeText(`${window.location.href}?application_id=${item.id}`);
    successNotification('Копирование ссылки на обращение', 'Ссылка на просмотр скопирована.');
  };

  const handleShow = item => () => {
    if (!item) {
      return;
    }
    setIsAssign(false);
    handleSetUrlParams({ procedure: procedureText, search, application_id: item.id });
  };

  const handleAssign = item => () => {
    if (!item) {
      return;
    }
    // handleSetUrlParams({ procedure: procedureText, search, application_id: item.id });
    loadApplication(item.id, true);
  };

  const handleReview = item => () => {
    if (!item) {
      return;
    }
    dispatch(showGlobalConfirm({
      confirmMessage: `Пересмотреть обращение № ${item.mais_egu_id || 'Без номера'}?`,
      confirmButtonText: 'Пересмотреть',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(reviewApplication(item.id)).then(() => {
        loadData();
        loadApplication(item.id);
        successNotification('Отправка на пересмотр', 'Отправка на пересмотр прошла успешно');
      }).catch(response => {
        errorNotification('Отправка на пересмотр', getResponseError(response));
      });
    }).catch(() => {});
  };

  const handleCloseForm = () => {
    if (currentApplication && isEdit) {
      setIsEdit(false);
      setShowForm(false);
      setShowView(true);
      setIsAssign(false);
      handleSetUrlParams({ procedure: procedureText, search, application_id: currentApplication.id });
      return;
    }
    handleClose();
  };

  const handleClose = () => {
    setIsEdit(false);
    setShowForm(false);
    setShowView(false);
    setIsAssign(false);
    setShowSelectProcedure(false);
    setShowForm(false);
    setSelectedProcedure(null);
    setShowRollbackPlan(false);
    handleRemoveUrlParams(['application_id']);
    dispatch(applicationFieldsValidationClear());
    clearCurrentState();
    setShowHistoryVersion(false);
    setIsBatchCommand(false);
    setSelected([]);
    setSelectedRow(null);
    setIsAllPageRowsSelected(false);
  };

  const handleCreateRollbackPlan = item => {
    if (!item) {
      return;
    }
    let root_models;
    if (Array.isArray(item)) {
      root_models = item?.map(id => ({
        root_model_type: 'application',
        root_model_id: id,
      }));
    } else if (item?.version) {
      root_models = [{
        target_version: item?.version,
        root_model_type: 'application',
        root_model_id: item?.subject_id || item?.id,
      }];
    } else {
      root_models = [{
        root_model_type: 'application',
        root_model_id: item?.subject_id || item?.id,
      }];
    }

    dispatch(createRollbackPlans({ root_models })).then(() => setShowRollbackPlan(true)).catch(responseLogWithNotification);
    setShowHistoryVersion(false);
  };

  const handleRollbackPlanGroup = () => () => {
    if (!Array.isArray(selected) || !selected?.length) {
      return;
    }
    if (isAllPageRowsSelected) {
      dispatch(loadApplicationIdList({
        filter: getValues(),
      })).then(data => {
        setSelected(data?.data);
        handleCreateRollbackPlan(data?.data);
      }).catch(responseLogWithNotification);
    } else {
      handleCreateRollbackPlan(selected);
    }
  };

  const handleShowHistoryVersion = item => () => {
    if (!item) {
      return;
    }
    setSelectedRow(item);
    setShowHistoryVersion(true);
  };

  const clearCurrentState = () => {
    dispatch(loadApplicationByIdClear()).catch(responseLogWithNotification);
  };

  function HeaderInfo() {
    const headerInfoBlock = document.getElementById('header-info-block');
    return headerInfoBlock ? (ReactDOM.createPortal(
      <div className="application-stats">
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus.in_work ? applicationStatus.in_work : 0}</div>
          <div className="as-label">Активные</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus.new ? applicationStatus.new : 0}</div>
          <div className="as-label">Новые</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.carriers ? applicationStatus.carriers : 0}</div>
          <div className="as-label">Перевозчики</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.carriers_legal_entity ? applicationStatus.carriers_legal_entity : 0}</div>
          <div className="as-label">Перевозчики ЮЛ</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.carriers_self_employed ? applicationStatus.carriers_self_employed : 0}</div>
          <div className="as-label">Перевозчики СМЗ</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.carriers_sole_proprietor ? applicationStatus.carriers_sole_proprietor : 0}</div>
          <div className="as-label">Перевозчики ИП</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.order_services ? applicationStatus.order_services : 0}</div>
          <div className="as-label">СЗЛТ</div>
        </div>
        <div className="as-block">
          <div className="as-value">{applicationStatus && applicationStatus?.vehicles ? applicationStatus.vehicles : 0}</div>
          <div className="as-label">ЛТ</div>
        </div>
      </div>,
      headerInfoBlock,
    )
    ) : null;
  }

  const renderContextMenu = item => (!isDraft ? (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={copyLink(item)}>
        Копировать ссылку
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотреть
      </Button>
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
          Редактировать
        </Button>
      ) : null}
      <Button variant="link" className="w-100 more-button" onClick={handleArchive(item)}>
        {item?.archived_at ? 'Перевести в активный' : 'Перевести в архивный'}
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleDeleteAndRestore(item)}>
        {!item?.deleted_at ? 'Перевести в удаленные' : 'Восстановить'}
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleShowHistoryVersion(item)}>
        История изменений
      </Button>
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={() => handleCreateRollbackPlan(item)}>
          Восстановить предыдущий статус
        </Button>
      ) : null}
    </div>
  ) : (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотреть
      </Button>
      {!isMobile ? (
        <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
          Редактировать
        </Button>
      ) : null}
      <Button variant="link" className="w-100 more-button" onClick={handleDeleteAndRestore(item)}>
        {!item?.deleted_at ? 'Перевести в удаленные' : 'Восстановить'}
      </Button>
    </div>
  ));
  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    // if (selectedRow && item.id === selectedRow.id) {
    //   classes.push('selected');
    // }
    const ed = moment(item.decision_deadline_date);
    const nvd = moment(item.notification_violation_date);
    const now = moment();
    if (item && item.archived_at) {
      classes.push('is_archive');
    }
    if ([APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.REVIEW, APPLICATION_STATUS.NEW, APPLICATION_STATUS.CHECKING, APPLICATION_STATUS.UPDATED].includes(item.status) && nvd.isValid() && now.diff(nvd, 'days') >= -1) {
      classes.push('notification_deadline');
    }
    if ([APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.REVIEW, APPLICATION_STATUS.NEW, APPLICATION_STATUS.CHECKING, APPLICATION_STATUS.UPDATED].includes(item.status) && ed.isValid() && now.diff(ed, 'days') === -2) {
      classes.push('deadline_2_day');
    }
    if ([APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.REVIEW, APPLICATION_STATUS.NEW, APPLICATION_STATUS.CHECKING, APPLICATION_STATUS.UPDATED].includes(item.status) && ed.isValid() && now.diff(ed, 'days') === -1) {
      classes.push('deadline_1_day');
    }
    if ([APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.REVIEW, APPLICATION_STATUS.NEW, APPLICATION_STATUS.CHECKING, APPLICATION_STATUS.UPDATED].includes(item.status) && (!ed.isValid() || now.diff(ed, 'days') >= 0)) {
      classes.push('deadline');
    }
    return classes.join(' ');
  };

  const indexSearch = rowFilterSettings.findIndex(row => row.name === 'search');
  const indexProcedure = rowFilterSettings.findIndex(row => row.name === 'procedure');
  if (indexSearch >= 0) {
    rowFilterSettings[indexSearch].inputProps = {
      value: search || getValues('search') || '',
      onChange: e => handleSetUrlParams({ procedure: procedureText, search: e.target.value || '' }),
    };
  }
  if (indexProcedure >= 0) {
    rowFilterSettings[indexProcedure].inputProps = getInputPropsWithSearch(getValues, searchParams, setSearchParams, 'procedure', []);
  }

  const handleSelectCheckBox = (item, check) => e => {
    const newSelectedList = check ? selected.filter(e => e !== item.id) : [...selected, item.id];
    setSelected(newSelectedList);
    e.stopPropagation();
  };

  const checkBoxColumnFormatter = (_, item) => {
    const check = selected.includes(item.id) || isAllPageRowsSelected;
    return (
      <div className="bordered-checkbox" onClick={handleSelectCheckBox(item, check)}>
        <CheckBoxInput
          inputProps={{
            value: check,
          }}
        />
      </div>
    );
  };

  const handleSelectHeaderCheckBox = e => {
    const idsPerPage = list?.map(i => i.id);
    if (isAllPageRowsSelected) {
      setIsAllPageRowsSelected(!isAllPageRowsSelected);
      const newSelectedList = selected.filter(f => !idsPerPage.includes(f));
      setSelected(newSelectedList);
      return;
    }
    const isSelectAllOnPage = list.every(i => selected.includes(i.id));
    if (isSelectAllOnPage) {
      setIsAllPageRowsSelected(!isAllPageRowsSelected);
      return;
    }
    setSelected([...selected, ...idsPerPage]);
    e.stopPropagation();
  };

  const checkBoxHeaderFormatter = () => {
    const idsPerPage = list?.map(i => i.id);
    const isAllPerPage = list.every(i => selected.includes(i.id));
    const isSome = (selected.some(i => !idsPerPage.includes(i)) || list.some(i => selected.includes(i.id))) && !isAllPerPage;
    return (
      <div
        className="bordered-checkbox"
        onClick={handleSelectHeaderCheckBox}
      >
        <CheckBoxInput
          className={classNames({ 'some-child': isSome }, { 'all-child': isAllPageRowsSelected })}
          inputProps={{
            value: isAllPerPage,
          }}
        />
      </div>
    );
  };

  const columns = [
    !isDraft && !isMobile
      ? {
        dataField: 'checkBox',
        headerClassName: 'check-box text-center column-relative',
        dataClassName: 'align-middle column-relative text-center justify-content-center',
        formatter: checkBoxColumnFormatter,
        headerFormatter: checkBoxHeaderFormatter,
      } : null,
    ...applicationColumns,
  ].filter(column => column);

  const createAdditionalColumn = () => {
    if (inSzlt) {
      return [...applicationAdditionalColumns, ...szltColumns];
    }
    if (inVehicle) {
      return [...applicationAdditionalColumns, ...vehicleColumns];
    }
    if (inCarrier) {
      return [...applicationAdditionalColumns, ...carrierColumns];
    }
    return [...applicationAdditionalColumns, ...carrierColumns, ...vehicleColumns, ...szltColumns];
  };

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileApplicationFooter
      control={control}
      search={search}
      procedureText={procedureText}
      isDraft={isDraft}
      searchParams={searchParams}
      columns={columns}
      createAdditionalColumn={createAdditionalColumn}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      handleSetUrlParams={handleSetUrlParams}
      getInputPropsWithSearch={getInputPropsWithSearch}
      setSearchParams={setSearchParams}
      handleCreate={handleCreate}
    />, element);
  };

  return (
    <div className="page application-page">
      <TimerLoader loading={loadingList || loadingApplicationStatus || loadingUserList || loadingFieldsValidation || loadingExportApplication} />
      <HeaderInfo />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.application' })}{title ? <span className="sub-title-text"> - {title}</span> : ''}</div>
        <div className="title-buttons">
          { Array.isArray(selected) && selected.length
            ? (
              <DropdownList
                className="ml-3 ms-3 button-list second"
                label={(
                  <>
                    <span className="load-button-label-text">Пакетная обработка</span>
                    <Icons className="load-icon-arrow" icon="arrow-down" customIcon />
                  </>
                )}
              >
                <>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleRollbackPlanGroup()}
                  >
                    Откат версий
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleSuspended(null, true)}
                  >
                    Приостановка
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleReturn(null, true)}
                  >
                    Возврат
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleDenied(null, true)}
                  >
                    Отказ
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleArchive(null, true)}
                  >
                    Перенос в архив
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleArchive(null, true, true)}
                  >
                    Перенос из архив
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleDelete(null, true)}
                  >
                    Удаление
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleGroupRestore}
                  >
                    Восстановить
                  </Button>
                  <Button
                    variant="link"
                    className="button-alternate menu-button grey-text"
                    onClick={handleAccept(null, true)}
                  >
                    Удовлетворение
                  </Button>
                </>
              </DropdownList>
            ) : null}
        </div>
      </div>
      {!isMobile ? (
        <ApplicationFilter
          control={control}
          search={search}
          procedureText={procedureText}
          isDraft={isDraft}
          searchParams={searchParams}
          columns={columns}
          selected={selected}
          createAdditionalColumn={createAdditionalColumn}
          defaultFilterValues={defaultFilterValues}
          getValues={getValues}
          reset={reset}
          handleSetUrlParams={handleSetUrlParams}
          getInputPropsWithSearch={getInputPropsWithSearch}
          setSearchParams={setSearchParams}
          handleCreate={handleCreate}
        />
      ) : null}
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  key={pageName}
                  onClickByRow={handleSelectRow}
                  onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                  rowClassFormatter={rowClassFormatter}
                  data={list}
                  changeSort={changeSort}
                  sort={sort}
                  columns={columns}
                  additionalColumns={createAdditionalColumn()}
                  name={`${pageName}-list`}
                  settingsFormatter={moreFormatter}
                  renderContextMenu={renderContextMenu}
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              key={pageName}
              data={list}
              columns={columns}
              name={`${pageName}-list`}
              additionalColumns={createAdditionalColumn()}
              onDoubleClickByRow={(item, event) => handleShow(item)(event)}
              settingsFormatter={moreFormatter}
              renderContextMenu={renderContextMenu}
              rowClassFormatter={rowClassFormatter}
            />
          )}
          <Pagination meta={listMeta} list={list} handleChangeMeta={loadData} />
        </div>
      </div>
      {showSelectProcedure ? (
        <ApplicationSelectProcedure
          onSelectProcedure={procedure => {
            clearCurrentState();
            setSelectedProcedure(procedure);
            setShowForm(true);
            setShowSelectProcedure(false);
            handleRemoveUrlParams(['new']);
          }}
          onClose={() => {
            handleClose();
            if (isAssign) {
              unAssign(currentApplication.id);
            }
          }}
        />
      ) : null}
      {showForm ? (
        <ApplicationForm
          key={selectedProcedure}
          currentApplication={currentApplication}
          isEdit={isEdit}
          selectedProcedure={selectedProcedure}
          fieldsValidation={fieldsValidation}
          loadData={loadData}
          onCancel={handleCloseForm}
          onClose={handleClose}
          handleSetUrlParams={handleSetUrlParams}
          title={title}
          titleFull={titleFull}
          loadApplication={loadApplication}
          isAssign={isAssign}
        />
      ) : null}
      {showView && currentApplication?.id && !isMobile
        ? (
          <ApplicationView
            loadApplication={loadApplication}
            loadData={loadData}
            unAssign={unAssign}
            isAssign={isAssign}
            handleEdit={handleEdit}
            handleAssign={handleAssign}
            handleReview={handleReview}
            onClose={handleClose}
            title={title}
            titleFull={titleFull}
          />
        ) : null}
      {showView && currentApplication?.id && isMobile
        ? (
          <MobileApplicationView
            loadApplication={loadApplication}
            loadData={loadData}
            unAssign={unAssign}
            isAssign={isAssign}
            handleEdit={handleEdit}
            handleAssign={handleAssign}
            handleReview={handleReview}
            onClose={handleClose}
            title={title}
            titleFull={titleFull}
          />
        ) : null}
      {selectedRow?.id && showHistoryVersion ? <VersionListDialog type={TYPE_ROLLBACK_ENUM.APPLICATION} id={selectedRow?.id} handleCreateRollbackPlan={handleCreateRollbackPlan} onClose={handleClose} /> : null}
      {rollbackPlan?.id && showRollbackPlan ? <RollbackPlanDialog rollbackPlanId={rollbackPlan?.id} onClose={handleClose} /> : null}
      {showReturnDialog ? (
        <ApplicationReturn
          withoutValidation
          close={() => setShowReturnDialog(false)}
          send={isBatchCommand ? batchCommand(selected, USER_COMMAND_NAMES.RETURNED) : returned}
        />
      ) : null}
      {showDeniedDialog ? (
        <ApplicationDenied
          withoutValidation
          close={() => setShowDeniedDialog(false)}
          send={isBatchCommand ? batchCommand(selected, USER_COMMAND_NAMES.DENIED) : denied}
        />
      ) : null}
      {showSuspendedDialog ? (
        <ApplicationSuspended
          withoutValidation
          close={() => setShowSuspendedDialog(false)}
          send={isBatchCommand ? batchCommand(selected, USER_COMMAND_NAMES.INACTIVE) : suspended}
        />
      ) : null}
      {isMobile ? renderFooter() : null}
    </div>
  );
}
